import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { PageHeader, Empty } from "@/components/shared";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Checkbox } from "@/components/ui/checkbox";

export default function Sites() {
  const [sites, setSites] = useState([]);
  const [domain, setDomain] = useState("");
  const [sub, setSub] = useState(true);
  const load = () => api.get("/merchant/sites").then((r) => setSites(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/merchant/sites", { domain, allow_subdomains: sub }); setDomain(""); toast.success("Domaine ajouté"); load(); }
    catch (e2) { toast.error(errMsg(e2)); }
  };
  const toggle = async (s, active) => { await api.patch(`/merchant/sites/${s.id}`, { active }); load(); };
  const del = async (s) => { if (!window.confirm(`Supprimer ${s.domain} ?`)) return; await api.delete(`/merchant/sites/${s.id}`); toast.success("Domaine supprimé"); load(); };

  return (
    <div>
      <PageHeader title="Sites & domaines" subtitle="Liste blanche des domaines autorisés à utiliser le widget avec votre clé publique. L'en-tête Origin/Referer est vérifié à chaque appel. Utilisez *.example.com pour un wildcard." />
      <form onSubmit={add} className="panel p-5 flex flex-col sm:flex-row gap-3 sm:items-center mb-6">
        <Input placeholder="shop.example.com ou *.example.com" value={domain} onChange={(e) => setDomain(e.target.value)} className="font-mono" data-testid="site-domain-input" required />
        <label className="flex items-center gap-2 text-sm text-zinc-300 whitespace-nowrap"><Checkbox checked={sub} onCheckedChange={(v) => setSub(!!v)} data-testid="site-subdomains-checkbox" /> Autoriser les sous-domaines</label>
        <Button type="submit" className="bg-amber-500 hover:bg-amber-400 text-zinc-950 font-semibold" data-testid="add-site-button">Ajouter</Button>
      </form>
      {sites.length === 0 ? <Empty text="Aucun domaine. Ajoutez votre premier site." /> : (
        <div className="panel divide-y divide-border">
          {sites.map((s) => (
            <div key={s.id} className="flex items-center justify-between p-4 gap-4" data-testid="site-row">
              <div className="min-w-0">
                <div className="font-mono text-sm text-zinc-100 truncate" data-testid="site-domain">{s.domain}</div>
                <div className="text-xs text-zinc-500">{s.allow_subdomains ? "sous-domaines autorisés" : "domaine exact"} · ajouté le {fmtDate(s.created_at)}</div>
              </div>
              <div className="flex items-center gap-4">
                <Switch checked={s.active} onCheckedChange={(v) => toggle(s, v)} data-testid="site-active-switch" />
                <button onClick={() => del(s)} className="text-zinc-500 hover:text-red-400 transition-colors" data-testid="delete-site-button"><Trash2 size={16} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
